import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/authContext";
import { Loader, Badge } from "@mantine/core";
import { IconCreditCard } from "@tabler/icons-react";
import AppHdWithReturnLeft from "../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft";

const AdminUsers = () => {
    const { getToken } = useContext(AuthContext);
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            const token = getToken();
            if (!token) { navigate("/adm/login"); return; }

            try {
                const res = await fetch(
                    "https://boldee-97d8d36af3bd.herokuapp.com/adm/bu/users",
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const data = await res.json();
                setUsers(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, [getToken, navigate]);

    if (loading) return (
        <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className="mrgT5">Chargement...</div>
        </div>
    );

    return (
        <div className="width95pCenter">
            <AppHdWithReturnLeft>Utilisateurs</AppHdWithReturnLeft>

            <p className="mrgT10 mrgB10">{users.length} utilisateur{users.length > 1 ? "s" : ""}</p>

            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
                <thead>
                    <tr style={{ borderBottom: "2px solid #ccc", textAlign: "left" }}>
                        <th style={{ padding: "8px 12px" }}>Société</th>
                        <th style={{ padding: "8px 12px" }}>Réseau</th>
                        <th style={{ padding: "8px 12px", textAlign: "center" }}>Collectivité</th>
                        <th style={{ padding: "8px 12px" }}>Nom</th>
                        <th style={{ padding: "8px 12px" }}>Email</th>
                        <th style={{ padding: "8px 12px" }}>Code parrainage</th>
                        <th style={{ padding: "8px 12px", textAlign: "center" }}>Carte</th>
                        <th style={{ padding: "8px 12px", textAlign: "center" }}>Annulations</th>
                        <th style={{ padding: "8px 12px" }}>Inscrit le</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(u => (
                        <tr key={u._id} style={{ borderBottom: "1px solid #eee" }}>
                            <td style={{ padding: "8px 12px" }}>{u.company}</td>
                            <td style={{ padding: "8px 12px" }}>{u.reseau}</td>
                            <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                {u.collectivite
                                    ? <Badge color="blue">Oui</Badge>
                                    : <span style={{ color: "#999" }}>Non</span>
                                }
                            </td>
                            <td style={{ padding: "8px 12px" }}>{u.name || "-"}</td>
                            <td style={{ padding: "8px 12px" }}>{u.email}</td>
                            <td style={{ padding: "8px 12px" }}>{u.referralCode}</td>
                            <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                {u.hasCard
                                    ? <Badge color="green" leftSection={<IconCreditCard size={12} />}>Enregistrée</Badge>
                                    : <Badge color="gray">Non enregistrée</Badge>
                                }
                            </td>
                            <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                {u.cancellationCount > 0
                                    ? <Badge color="red">{u.cancellationCount}</Badge>
                                    : <span style={{ color: "#999" }}>0</span>
                                }
                            </td>
                            <td style={{ padding: "8px 12px" }}>
                                {new Date(u.createdAt).toLocaleDateString("fr-FR")}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminUsers;
